import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import * as S from '@/components/Ad/Promotions/Promotions.styles';
import { Promotion } from '@/components/Ad/Promotions/Promotion';
import { AdKind } from '@/api/types/common.types';
import { useAdDetails } from '@/views/Ads/useAdDetails';
import { promotions } from '@/components/Ad/Promotions/Promotions.constants';
import { getLessPrice } from '@/components/Ad/Promotions/Promotions.helpers';
import { useIsAuthor } from '@/hooks/useIsAuthor';
import { AdStatus } from '@/types';
import { Divider } from '@/components/UI/Divider/Divider.styles';
import { AdPageTestIds } from '@/__e2e__/testIds/ad-page';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';
import { useServerDataContext } from '@/contexts';

interface Props {
  onSelectPromotion: (type: AdKind) => void;
}

export const Promotions: FC<Props> = ({ onSelectPromotion }) => {
  const { t } = useTranslation();
  const { adDetails } = useAdDetails();
  const { initialAdDetails } = useServerDataContext();
  const adData = adDetails ?? initialAdDetails;
  const isAuthor = useIsAuthor();

  if (!adData) {
    return (
      <S.Box>
        {Array.from({ length: 3 }, (_, index) => (
          <SkeletonLoader key={index} borderRadius={14} height={60} />
        ))}
      </S.Box>
    );
  }

  if (adData.status === AdStatus.Rejected) {
    return null;
  }

  return (
    <>
      <S.Box data-testid={AdPageTestIds.promotions.box}>
        {isAuthor && (
          <S.Title $variant="3">{t('pages.ad.sell_faster')}</S.Title>
        )}
        {promotions(
          t,
          getLessPrice(adData.bumpServices[0]),
          getLessPrice(adData.vipServices[0]),
          getLessPrice(adData.featuredServices[0]),
          adData.status === AdStatus.Published
        ).map(promotion => (
          <Promotion
            key={promotion.type}
            promotion={promotion}
            onSelect={onSelectPromotion}
          />
        ))}
      </S.Box>

      {isAuthor && <Divider $isSmall />}
    </>
  );
};
